import { createSlice } from '@reduxjs/toolkit';

import { TExperimentsState } from 'shared/types/experiment';

const experimentsSlice = createSlice({
  name: 'experiments',
  initialState: [] as TExperimentsState,
  reducers: {},
});

export const { reducer: experimentsReducer } = experimentsSlice;
